import Cookies from 'js-cookie';
import uuid from 'uuid/v4';
import Utils from './utils';
import Uds from './uds';

const udsSavedFlag = 'uds_saved';

const saveId = (id) => {
  Uds.saveId(id).then(() => {
    Cookies.set(udsSavedFlag, true);
  }).catch(({ response }) => {
    if (!response) {
      console.log('UDS didn\'t return any response. See network log.');
      return;
    }

    const errorCode = response.data.errors[0].code;
    if (errorCode === 'ID_HAS_BEEN_ALREADY_TAKEN') {
      Cookies.set(udsSavedFlag, true);
    }
  });
};

const isUdsSaved = () => Cookies.get(udsSavedFlag) === 'true';

const getId = () => {
  const cookieAnonymousId = Cookies.get('ajs_anonymous_id');

  if (cookieAnonymousId) {
    const oldId = Utils.removeQuotes(cookieAnonymousId);
    if (!isUdsSaved()) {
      saveId(oldId);
    }
    return oldId;
  }

  const newId = uuid();
  saveId(newId);
  return newId;
};

export default { getId };
